import React from "react";
import Navbar from "../../../Navbar/Navbar";
import AddproductRightSide from "./AddproductRightSide";
import AddProductLeftSide from "./AddProductLeftSide";

const AddProduct = () => {
  return (
    <>
      <Navbar />
      <div className="mt-5"></div>
      <div className="row">
        <div className="col-12 col-lg-8 ">
          <AddProductLeftSide />
        </div>
        <AddproductRightSide />
      </div>
    </>
  );
};

export default AddProduct;
